import AddIcon from "@mui/icons-material/Add";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { snakeCase } from "lodash";
import Typography from "@mui/material/Typography";
import { getSpecificationPreviewText } from "./master-product-field.util";
import { misc, primary } from "app/themes/colors";
import { MasterProduct } from "services/types/master-products.type";

type MasterProductListItemProps = {
  props: object;
  option: MasterProduct;
  search: string;
  isNew?: boolean;
};

export default function MasterProductListItem({
  props,
  search,
  option,
  isNew = false,
}: MasterProductListItemProps) {
  return (
    <ListItem
      {...props}
      key={option.id}
      sx={{
        mb: 0.5,
      }}
      data-testid="master-product-item"
    >
      <Stack
        spacing={1}
        direction="row"
        justifyContent="center"
        alignContent="center"
      >
        <ListItemText
          disableTypography={!isNew}
          primaryTypographyProps={
            isNew ? { fontWeight: "fontWeightBold" } : undefined
          }
          secondary={
            <Stack
              direction="row"
              sx={{
                color: misc.grayAsphalt,
                mt: 0.5,
              }}
              rowGap={1}
            >
              {option.id === -1 && (
                <Typography sx={{ fontWeight: 700, color: primary[400] }}>
                  {search.length
                    ? `Add "${search}" as new Master Product`
                    : `Add new Master Product`}
                </Typography>
              )}
              {option.id !== -1 &&
                getSpecificationPreviewText(option).map((text, index) => (
                  <Typography
                    key={option.id + "_" + snakeCase(text)}
                    sx={{ pt: 0.25 }}
                  >
                    {text}
                  </Typography>
                ))}
            </Stack>
          }
        >
          {option.display_name}
        </ListItemText>
        {isNew && (
          <ListItemIcon>
            <AddIcon sx={{ color: primary[400] }} />
          </ListItemIcon>
        )}
      </Stack>
    </ListItem>
  );
}
